import Credentials from './CredentialsContainer';

export default Credentials;
